import { clientEnvironment } from "../config/env";

export const featureFlags = Object.freeze({
  aiUiEnabled: clientEnvironment.aiUiEnabled,
  telegramIntegration: false,
  n8nIntegration: false,
});
